// extracted by mini-css-extract-plugin
module.exports = {"select":"CustomSelect_select__aMfKe"};